if (!customElements.get('cart-recommendation')) {
  class CartRecommendation extends HTMLElement {
    constructor() {
      super();

      // Select elements and bind event listeners immediately
      this.cartProfessionalTrue = this.querySelector('[data-cart-profession="true"]');
      this.specialistName = this.querySelector('[data-specialist-name]');
      this.specialistIdInput = this.querySelector('[data-specialist-id]');
      this.specialistId = this.specialistIdInput ? this.specialistIdInput.value : '';
      this.requiredMessage = this.querySelector('[data-cart-professional-required-message]');
      this.form = this.closest('form#cart_form');
      this.radioButtons = this.querySelectorAll('input[type="radio"][data-cart-profession]');

      this.addEventListeners();
      this.handleAffiliatedSpecialist();
    }

    addEventListeners() {
      // Add event listeners to radio buttons and specialistName input
      this.radioButtons.forEach((button) => {
        button.addEventListener('change', () => this.validateForm());
      });

      this.specialistName.addEventListener('input', () => this.validateForm());

      this.form.addEventListener('submit', (e) => {
        if (!this.validateForm()) {
          this.requiredMessage.style.display = 'block';
          e.preventDefault(); // Block form submission if validation fails
        }
        // If both specialist name and ID are filled in, clear the name field
        if (this.specialistName && this.specialistId) {
          this.specialistName.value = '';
        }
      });
    }

    validateForm() {
      const radioChecked = Array.from(this.radioButtons).some((radio) => radio.checked); // Check if any radio is selected
      const specialistNameEmpty =
        this.cartProfessionalTrue.checked &&
        this.specialistName.value.trim() === '' &&
        !this.specialistId;

      if (!radioChecked) {
        this.requiredMessage.style.display = 'block';
        return false;
      }

      if (specialistNameEmpty) {
        return false;
      }

      this.requiredMessage.style.display = 'none';
      return true;
    }

    handleAffiliatedSpecialist() {
      //specialist affiliate link logic
      /**
       * Cart specialist fields
       */

      // Get specialist ID from customer tag (liquid), localStorage, or cookies
      if (!this.specialistId) {
        if (typeof Storage !== 'undefined') {
          this.specialistId = window.localStorage.getItem('ref');
        } else {
          const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
            const [key, value] = cookie.split('=');
            acc[decodeURIComponent(key)] = decodeURIComponent(value);
            return acc;
          }, {});
          this.specialistId = cookies['ref'];
        }
      }
      // If specialist ID is set, set the value of the specialist ID input field and hide the specialist pane
      if (this.specialistId) {
        this.specialistIdInput.value = this.specialistId;
        this.specialistIdInput.setAttribute('data-cart-specialist-id', this.specialistId);
        this.querySelector('[data-cart-professional-true-label]').click();
        this.querySelector('[data-cart-professional]').classList.add('hidden');

        if (window.debugMode) {
          console.log('SpecialistID: ' + this.specialistId);
        }
      }
    }
  }

  window.CartRecommendation = CartRecommendation;

  customElements.define('cart-recommendation', CartRecommendation);
}
